import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { verifyEmail } from "../../actions/authActions";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import Typography from "@mui/material/Typography";

const Verify = (props) => {
    let params = useParams();

    useEffect(() => {
        props.verifyEmail({'verification': params.verification});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                <MarkEmailReadIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Your email has been verified
            </Typography>
        </Box>
    )
}

export default connect(null, { verifyEmail })(Verify)
